import { CampaignModule } from 'utils/i18n/TModules';

// Translation Keys And Paths
export const CampaignListTableKey = `CampaignListTable`;
export const TCampaignListTable = `${CampaignModule}:${CampaignListTableKey}`;

export const CampaignListPageKey = `CampaignListPage`;
export const TCampaignListPage = `${CampaignModule}:${CampaignListPageKey}`;

export const CampaignCreatePageKey = `CampaignCreatePage`;
export const TCampaignCreatePage = `${CampaignModule}:${CampaignCreatePageKey}`;

export const CampaignReviewPageKey = `CampaignReviewPage`;
export const TCampaignReviewPage = `${CampaignModule}:${CampaignReviewPageKey}`;

export const ReferralRewardModeKey = `ReferralRewardMode`;
export const TReferralRewardMode = `${CampaignModule}:${ReferralRewardModeKey}`;

export const ReferralTierLadderKey = `ReferralTierLadder`;
export const TReferralTierLadder = `${CampaignModule}:${ReferralTierLadderKey}`;

export const ReferralBulkActionsKey = `ReferralBulkActions`;
export const TReferralBulkActions = `${CampaignModule}:${ReferralBulkActionsKey}`;

export const ReferralReportsKey = `ReferralReports`;
export const TReferralReports = `${CampaignModule}:${ReferralReportsKey}`;

export const ReferralAnalyticsKey = `ReferralAnalytics`;
export const TReferralAnalytics = `${CampaignModule}:${ReferralAnalyticsKey}`;
